import axios from 'axios';
import Configdata from './Defaultdata';

 
 export const reducearray=(arr: any)=>{
     let farr = [{}];
      if(arr){
	     if(arr.length > 0){
		for(let i =0;i< arr.length;i++){
                
                 const rv = arr[i][0];
		 
		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 1) farr.shift();
	return farr;
      }	

     export const cnvrtdropdown=(arrcomp: any,vf: any,nf: any)=>{
	let ardrp = [{}]; 
      if(arrcomp.length > 0){
        for(let i =0;i< arrcomp.length;i++){
              
                 const rv = arrcomp[i];
		
		let obj = {value: rv[vf], label: rv[nf] } 
		 
		 ardrp.push(obj);
	}
	ardrp.shift();
      }
	return ardrp;
    }
